import app from 'flarum/common/app';
app.initializers.add('dashzeveg-ads-manager-common', () => {
  // console.log('[dashzeveg/flarum-ads-manager] Hello, forum and admin!');
});